<div class="tickets-dashboard">
  <div class="tickets-dashboard__shell">
    <section class="tickets-hero">
      <div>
        <span class="tickets-hero__eyebrow">Centro operativo</span>
        <h1>Dashboard Operativo</h1>
        <p>Seguimiento ejecutivo de los modulos del COS para identificar carga activa, demanda y concentraciones de trabajo.</p>
      </div>

      <div class="tickets-hero__actions">
        <button
          *ngIf="gestion"
          type="button"
          class="tickets-button tickets-button--ghost"
          (click)="abrirGestion()">
          <mat-icon>{{ gestion.icon }}</mat-icon>
          <span>Gestionar</span>
        </button>
        <button
          *ngIf="activeDashboard"
          type="button"
          class="tickets-button tickets-button--primary"
          (click)="actualizarDashboardActivo()"
          [disabled]="cargando">
          <mat-icon>refresh</mat-icon>
          <span>Actualizar</span>
        </button>
      </div>
    </section>

    <app-hoy-en-el-equipo></app-hoy-en-el-equipo>

    <section class="dashboard-tabs" aria-label="Dashboards disponibles" *ngIf="tabsVisibles.length > 0; else sinModulosTpl">
      <button
        *ngFor="let tab of tabsVisibles"
        type="button"
        class="dashboard-tab"
        [class.dashboard-tab--active]="activeDashboard === tab.id"
        (click)="seleccionarDashboard(tab.id)">
        <mat-icon>{{ tab.icon }}</mat-icon>
        <span>{{ tab.label }}</span>
      </button>
    </section>

    <!-- Una pestaña por modulo; todas con #pestana para que el cascaron llegue a la activa. -->
    <app-dashboard-tickets #pestana *ngIf="activeDashboard === 'tickets'"></app-dashboard-tickets>
    <app-dashboard-defectos #pestana *ngIf="activeDashboard === 'defectos'"></app-dashboard-defectos>
    <app-dashboard-asistencia #pestana *ngIf="activeDashboard === 'asistencia'"></app-dashboard-asistencia>
    <app-dashboard-proyectos #pestana *ngIf="activeDashboard === 'proyectos'"></app-dashboard-proyectos>
    <app-dashboard-denuncias #pestana *ngIf="activeDashboard === 'denuncias'"></app-dashboard-denuncias>
    <app-dashboard-riesgos #pestana *ngIf="activeDashboard === 'riesgos'"></app-dashboard-riesgos>
    <app-dashboard-ia #pestana *ngIf="activeDashboard === 'ia'"></app-dashboard-ia>
  </div>
</div>

<ng-template #sinModulosTpl>
  <section class="tickets-card">
    <div class="tickets-empty">No tienes modulos con indicadores en el inicio</div>
  </section>
</ng-template>
